import { render, staticRenderFns } from "./MyLogin.vue?vue&type=template&id=3535e8f8&"
import script from "./MyLogin.vue?vue&type=script&lang=js&"
export * from "./MyLogin.vue?vue&type=script&lang=js&"
import style0 from "./MyLogin.vue?vue&type=style&index=0&id=3535e8f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports